import type { CreateRoomBody } from 'shared';

/**
 * HTTP calls. Everything is same-origin: in production Nest serves this bundle,
 * and in dev Vite proxies /api and /socket.io to it.
 */

export interface CreatedRoom {
  roomId: string;
  roomToken: string;
  adminToken: string;
}

export class ApiError extends Error {
  constructor(
    public readonly code: string,
    message: string,
  ) {
    super(message);
  }
}

async function fail(res: Response): Promise<never> {
  let code = 'INVALID_PAYLOAD';
  let message = res.statusText;
  try {
    const body = (await res.json()) as { code?: string; message?: string };
    code = body.code ?? code;
    message = body.message ?? message;
  } catch {
    /* keep the status text */
  }
  throw new ApiError(code, message);
}

export async function createRoom(body: CreateRoomBody): Promise<CreatedRoom> {
  const res = await fetch('/api/rooms', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) await fail(res);
  return (await res.json()) as CreatedRoom;
}

export async function uploadAvatar(
  roomToken: string,
  playerToken: string,
  blob: Blob,
): Promise<void> {
  const res = await fetch(`/api/rooms/${roomToken}/avatar`, {
    method: 'POST',
    headers: { 'content-type': blob.type, 'x-player-token': playerToken },
    body: blob,
  });
  if (!res.ok) await fail(res);
}
